export const journeyBuilderRoutes = {
  parentRoute: '/journey-designer',
  viewJourney: '/journey-designer/journeys',
  createJourney: '/journey-designer/journeys/create',
  importJourney: '/journey-designer/journeys/upload-files',
  journeyCanvas: '/journey-designer/journeys/:mode/:id/:version',
  journeyCanvasStep: '/journey-designer/journeys/:mode/:id/:version/steps/:stepName',
};

export interface JourneyCanvasUrlParams {
  mode: string;
  id: string;
  version: string | number;
  stepName?: string;
}

export const buildJourneyCanvasUrl = ({ mode, id, version, stepName }: JourneyCanvasUrlParams): string => {
  const base = `/journey-designer/journeys/${mode}/${encodeURIComponent(id)}/${version}`;
  return stepName ? `${base}/steps/${encodeURIComponent(stepName)}` : base;
};
